import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { GenericSearchListBlock } from '../../_blocks/GenericSearchList';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { FetchType } from '../../types/api/FetchType';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { isEmptyBlock } from '../../types/api/Block';

export type GenericSearchListWidget = ContextWidget<GenericSearchListBlock, WidgetType.genericsearchlist>;
function getWidgetTitle(block: GenericSearchListWidget['blocks'][0]) {
  if (block.fetchType === FetchType.lazy) {
    return null;
  }
  if (isEmptyBlock(block)) {
    return null;
  }
  return block.embedded.widgetTitle;
}
/**
 * Widget to map GenericSearchList blocks with possibility of a custom widgetTitle.
 */
export function GenericSearchListWidget({ blocks, ...props }: GenericSearchListWidget) {
  const { t } = useSonTranslation('GenericSearchList');

  const widgetTitle = getWidgetTitle(blocks[0]) || t('headline');

  return <DefaultContextWidget icon={Icons.EXTENDED_CONTENT} title={widgetTitle} blocks={blocks} {...props} />;
}
